import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card'
import { Avatar, AvatarFallback, AvatarImage } from '@/components/ui/avatar'

export const RecentActivity = () => {
  const activities = [
    {
      name: 'João Silva',
      email: 'joao.silva@empresa.pt',
      action: 'Subscreveu ao plano Pro',
      amount: '+€199,00',
      avatar: 'https://img.usecurling.com/ppl/thumbnail?gender=male&seed=1',
      initials: 'JS',
    },
    {
      name: 'Maria Santos',
      email: 'maria.santos@loja.pt',
      action: 'Nova encomenda #3421',
      amount: '+€49,00',
      avatar: 'https://img.usecurling.com/ppl/thumbnail?gender=female&seed=2',
      initials: 'MS',
    },
    {
      name: 'Pedro Costa',
      email: 'pedro.c@tech.pt',
      action: 'Atualizou o perfil',
      amount: 'N/A',
      avatar: 'https://img.usecurling.com/ppl/thumbnail?gender=male&seed=3',
      initials: 'PC',
    },
    {
      name: 'Ana Ferreira',
      email: 'ana.f@studio.pt',
      action: 'Novo ticket de suporte',
      amount: 'N/A',
      avatar: 'https://img.usecurling.com/ppl/thumbnail?gender=female&seed=4',
      initials: 'AF',
    },
    {
      name: 'Rui Martins',
      email: 'rui.m@startup.io',
      action: 'Exportou relatório mensal',
      amount: 'N/A',
      avatar: 'https://img.usecurling.com/ppl/thumbnail?gender=male&seed=5',
      initials: 'RM',
    },
  ]

  return (
    <Card className="col-span-4 lg:col-span-2 xl:col-span-1 shadow-sm border-slate-200/60 bg-white h-full">
      <CardHeader>
        <CardTitle className="text-base font-semibold text-slate-900">
          Atividade Recente
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {activities.map((item, index) => (
            <div key={index} className="flex items-center gap-4">
              <Avatar className="h-9 w-9 border border-slate-100 shrink-0">
                <AvatarImage
                  src={item.avatar}
                  alt={item.name}
                  className="object-cover"
                />
                <AvatarFallback className="text-xs font-medium bg-slate-100 text-slate-500">
                  {item.initials}
                </AvatarFallback>
              </Avatar>

              <div className="flex flex-col flex-1 min-w-0 gap-0.5">
                <p className="text-sm font-medium leading-none text-slate-900 truncate">
                  {item.name}
                </p>
                <p className="text-xs text-slate-500 truncate">{item.action}</p>
              </div>

              {item.amount !== 'N/A' && (
                <div className="font-medium text-sm text-green-600 shrink-0 tabular-nums">
                  {item.amount}
                </div>
              )}
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  )
}
